import { Button, Dropdown, Layout, Space, Typography, Tag } from 'antd'
import type { MenuProps } from 'antd'
import {
  BookOutlined,
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useUIStore } from '@/stores/uiStore'
import { useAuthStore } from '@/stores/authStore'

const { Header } = Layout
const { Text } = Typography
type MenuItem = Required<MenuProps>['items'][number]

export default function Topbar() {
  const navigate = useNavigate()
  const { sidebarCollapsed, toggleSidebar } = useUIStore()
  const { actor, roles, authMode, logout, permissions } = useAuthStore()

  const manualItems = [
    permissions.includes('message:read')
      ? { key: '/manual/reception', label: '售后接待手册', icon: <BookOutlined /> }
      : null,
    permissions.includes('user:manage')
      ? { key: '/manual/admin', label: '管理员手册', icon: <BookOutlined /> }
      : null,
  ].filter(Boolean) as MenuItem[]

  const handleLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <Header style={{
      background: '#fff',
      padding: '0 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #f0f0f0',
      height: 48,
      lineHeight: '48px',
    }}>
      <Space>
        <span onClick={toggleSidebar} style={{ cursor: 'pointer', fontSize: 16 }}>
          {sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </span>
        <Text strong style={{ fontSize: 15 }}>售后工单操作台</Text>
        {authMode === 'dev_header' && (
          <Tag color="orange" style={{ fontSize: 10, lineHeight: '18px' }}>开发模式</Tag>
        )}
      </Space>
      <Space size="small">
        {manualItems.length > 0 && (
          <Dropdown
            menu={{
              items: manualItems,
              onClick: ({ key }) => navigate(String(key)),
            }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Button type="text" size="small" icon={<BookOutlined />}>
              用户手册 <DownOutlined />
            </Button>
          </Dropdown>
        )}
        <Text type="secondary" style={{ fontSize: 12 }}>
          {actor || '未登录'}
        </Text>
        {roles.map((role) => (
          <Tag key={role} color="blue" style={{ fontSize: 11 }}>{role}</Tag>
        ))}
        {authMode === 'password' && (
          <Button type="text" size="small" icon={<KeyOutlined />} onClick={() => navigate('/account/password')}>
            改密
          </Button>
        )}
        <Button type="text" size="small" icon={<LogoutOutlined />} onClick={handleLogout}>
          退出
        </Button>
      </Space>
    </Header>
  )
}
